export default {
  EBA_IDLE_0: 'multiplier_idle',
  EBA_IDLE_1: 'multiplier_idle2',
  EBA_IDLE_2: 'multiplier_idle3',

  EBA_START_0: 'multiplier_run',
  EBA_START_1: 'multiplier_run2',

  EBA_WIN_0: 'multiplier_win',
  EBA_WIN_1: 'multiplier_win2',
  EBA_EXIT: 'multiplier_exit'
};
